import type { ComponentType } from "react";
import { Obd2Scanner } from "./Obd2Scanner.tsx";
import { LaughingMan } from "./LaughingMan.tsx";
import { TerminalChallenge } from "./TerminalChallenge.tsx";

// Shared contract for every rich-challenge renderer. The flow is identical to a
// plain text challenge — only the presentation differs:
//   - payload : server-authored JSON string (the objective's challenge_payload),
//               delivered on InteractNPCResponse. This is how server content
//               threads into a rich component.
//   - response: the live result string ("" | "Looking up..." | "Correct
//               answer. <clue>" | "Incorrect answer. ..."). Renderers key their
//               win/lose visuals off this.
//   - onSubmit: hand an answer back to the dialog, which runs it through the
//               existing completeObjective -> server-validation path.
//   - onClose : close the challenge dialog.
export interface RichChallengeProps {
  payload: string;
  response: string;
  onSubmit: (answer: string) => void;
  onClose: () => void;
  title?: string;
  text?: string;
}

// challenge_type -> renderer. Add a new entry to ship a new rich experience;
// nothing else in the dialog needs to change.
export const RICH_CHALLENGE_RENDERERS: Record<
  string,
  ComponentType<RichChallengeProps>
> = {
  obd2_scanner: Obd2Scanner,
  laughing_man: LaughingMan,
  terminal: TerminalChallenge,
};

export function getRichChallengeRenderer(
  challengeType?: string,
): ComponentType<RichChallengeProps> | null {
  if (!challengeType) return null;
  return RICH_CHALLENGE_RENDERERS[challengeType] || null;
}
